import React from 'react';
import { subscribe } from 'react-contextual';
import { Container, Row} from 'reactstrap';
import TagsBlock from './tagBlock';

const TagsPanel = ({tags}) => (
	<Container className="panel-padding">
		<Row className="d-flex gi-tagspanel">
				<TagsBlock tags={tags} className="gi-tagspanel" />
		</Row>
	</Container>
);

export default subscribe()(TagsPanel);
